import * as React from 'react';
import { CaretDownOutlined } from '@ant-design/icons';
import { Input } from 'antd';
import { NiSelect } from '@component/ant-component/select';
import {
  Operation,
  NiCommonCascader,
  SELECTION_KEY
} from '@config/index';
import {
  Attribute,
  ParameterConfig,
  Reference,
  ReferenceNode,
  ResponseConfig
} from '@interface/index';
import { localizedString } from '@locale/index';
import { ReferenceTextArea } from '@component/index';
import { ParameterMapStore } from '@lib/index';

export type ValueSwitchPropsConfig = {
  attribute?: Attribute;
  disabled?: boolean;
  variable: Reference;
  // tslint:disable-next-line
  onChange: (next: any[]) => void;
  data: { operation: number; value: any[]; };
  placeholder?: string;
  isBoolean: boolean;
  isTable: boolean;
  isMultiValue: boolean;
  parameters: ParameterConfig[];
};

export interface ValueSwitchStateConfig {
  value: any[];
}

export const ValueSwitch = (props: ValueSwitchPropsConfig) => {

  function getTextArea() {

    return <ReferenceTextArea
      key={props.data.value[0] || 'value-textarea'}
      disabled={props.disabled}
      style={{ width: '100%', flex: 1 }}
      parameterMap={ParameterMapStore.all()}
      className="refer-input"
      data={props.data.value[0]}
      initParameters={props.parameters}
      update={(value: any) => {
        props.onChange([value]);
      }}
    />;
  }

  function getValueComp() {
    if (props.data.operation === Operation.IsTypeCondition) {
      return <NiCommonCascader
        disabled={props.disabled}
        selectionkey={SELECTION_KEY.AVAILABLE_SUB_INSTANCE}
        rootpath={props.variable.map((item: ReferenceNode) => ({
          value: item.id,
          value_type: item.type
        }))}
        disabledvalues={[]}
        value={props.data.value}
        onChange={(next: any) => {
          props.onChange(next);
        }}
      />;
    }

    if (props.isBoolean) {
      return (
        <NiSelect
          style={{
            minWidth: 144,
            width: '100%'
          }}
          allowClear
          showSearch
          disabled={props.disabled}
          suffixIcon={<CaretDownOutlined />}
          value={props.data.value[0]}
          placeholder={localizedString('condition_value_placeholder1') || props.placeholder}
          onChange={(next: any) => {
            props.onChange([next]);
          }}
        >
          <NiSelect.Option key={'true'} value={'true'}>
            True
          </NiSelect.Option>

          <NiSelect.Option key={'false'} value={'false'}>
            False
          </NiSelect.Option>
        </NiSelect>
      );
    }

    const multiValue = !props.isTable && (props.isMultiValue ||
      props.data.operation === Operation.InCondition ||
      props.data.operation === Operation.NotInCondition);

    if (multiValue) {
      return (
        <NiSelect
          style={{
            width: '100%'
          }}
          disabled={props.disabled}
          suffixIcon={< CaretDownOutlined />}
          mode="tags"
          value={props.data.value as any}
          placeholder={
            localizedString('condition_value_placeholder_multi') || props.placeholder
          }
          onChange={(value: any) => {
            props.onChange(value);
          }}
        />
      );
    }

    return getTextArea();
  }

  return (
    <Input.Group style={{ display: 'flex' }} compact>
      {getValueComp()}
    </Input.Group>
  );
};
